import { render, staticRenderFns } from "./TrademarkNoteTypeList.vue?vue&type=template&id=0b54d2b3&"
import script from "./TrademarkNoteTypeList.vue?vue&type=script&lang=js&"
export * from "./TrademarkNoteTypeList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkNoteTypeList.vue?vue&type=style&index=0&id=0b54d2b3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports